import { colsToUUIDObject } from "src/redux/utils/convertToUUIDKeys";

import type { IGuernseyRow, TGuernseyRows } from "./Guernsey.types";
/**
 * Parses Guernsey content into a UUID-based structure.
 *
 * @param content - The content to be parsed, typically an object where keys represent categories and values are arrays of `ICol` objects.
 * @returns An object where each key corresponds to the original key, and the values are arrays of objects with UUID-based column keys.
 */
const parseGuernseyContentToUUID = (
  content: Record<string, IGuernseyRow[]>,
) => {
  const parsedContent: any = {};
  Object.entries(content).forEach(([key, content]) => {
    const newContent: any = content.map(el => {
      return {
        ...el,
        cols: colsToUUIDObject(el.cols as any, false, true),
      };
    });
    parsedContent[key] = newContent;
  });
  return parsedContent;
};
/**
 * Parses content into input rows for a specific type and optionally processes it for summary or UUID-based structure.
 *
 * @param content - The content to be parsed, typically an object where keys represent categories and values are arrays of `IGuernseyRow` objects.
 * @param type - The type of rows to parse, corresponding to a key in the content object.
 * @param summary - A boolean indicating whether to process the content into a UUID-based structure.
 * @param lbeid - An optional string representing the ID of the entry to associate with the parsed rows.
 * @returns An object where keys are column indices and values are objects containing column data.
 */
const parseIntoInputRows = (
  content: Record<string, IGuernseyRow[]>,
  type: string,
  summary: boolean | undefined,
  lbeid: string | undefined,
) => {
  const inputRows: TGuernseyRows = {};
  let parsedContent = content;
  if (summary) {
    parsedContent = parseGuernseyContentToUUID(content);
  }
  parsedContent[type]?.forEach((row: IGuernseyRow) => {
    Object.entries(row.cols).forEach(([key, col]) => {
      inputRows[String(col.index)] = {
        ...inputRows[String(col.index)],
        [key]: { ...col, lbeid } as any,
      };
    });
  });
  return inputRows;
};
export { parseGuernseyContentToUUID, parseIntoInputRows };
